// extracted by mini-css-extract-plugin
module.exports = {"panel":"OrderCampaignMaterials_panel__3P5xz","sendText":"OrderCampaignMaterials_sendText__3T6f4"};